import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal from "./Reveal";

const FAQS = [
  {
    q: "How fast do I actually get the money?",
    a: "Most applications get a decision within 60 seconds. After you e-sign your offer, funds are transferred the same business day — often within hours.",
  },
  {
    q: "Does checking my rate hurt my credit score?",
    a: "No. The robot runs a soft credit check to show you real rates, and soft checks are invisible to your score. Only a final hard check happens if you accept the loan.",
  },
  {
    q: "What can I borrow for?",
    a: "Anything legal and useful: debt consolidation, vehicles, home improvement, business capital, major purchases — or a personal project you'd rather not explain to a bank branch.",
  },
  {
    q: "Are there any fees?",
    a: "No origination fees, no prepayment penalties, no maintenance fees. You repay the principal and the interest — that's it. Every cost is shown before you sign.",
  },
  {
    q: "What if the robot says no?",
    a: "Your file is passed to a human underwriter for a second look within one business day. Machines are fast; humans catch context.",
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-3xl px-5 md:px-10">
        <Reveal className="mb-12">
          <p className="label-mono text-[#007AFF] mb-4">FAQ</p>
          <h2 className="font-display font-bold tracking-[-0.02em] leading-[1.02] text-[#0A1628] text-4xl md:text-6xl">
            Asked, answered.
          </h2>
        </Reveal>

        <div className="border-t border-black/8">
          {FAQS.map((f, i) => (
            <Reveal key={i} delay={i * 0.05} className="border-b border-black/8">
              <button
                data-testid={`faq-q-${i}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-6 py-6 text-left group"
              >
                <span className="font-display text-lg md:text-xl font-semibold text-[#0A1628] group-hover:text-[#007AFF] transition-colors">
                  {f.q}
                </span>
                <span
                  className={`shrink-0 flex h-9 w-9 items-center justify-center rounded-full border border-black/10 transition-all duration-300 ${
                    open === i ? "rotate-45 bg-[#007AFF] border-[#007AFF] text-white" : "text-[#0A1628]"
                  }`}
                >
                  <Plus className="w-4 h-4" />
                </span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    key="content"
                    data-testid={`faq-a-${i}`}
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="pb-7 pr-12 text-base leading-relaxed text-[#52525B]">{f.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
